<template>
  <div class="box">
      <img
          src="./_20241111082403.png"
          alt=""
          class="bg-title"
      />
      <div class="ccwlglxt" style="margin-top: 30px;;">
          <img :src="'https://spare4.qiyasoft.top/storage/547f3ed73176918cf0b834947a508e7e1709087162.png'" class="headimgurl" alt="">
      </div>
      <div class="ccwlglxt1" style="margin-top: 30px;;">杭州鑫真机械有限公司</div>
      <div style="margin-top: -60px;">
          <div class="active-box1">
              <div @click="yyrk" style="z-index:999;">
                  <img style="width:36px;height:36px;" src="./image.png" alt="">
                  <span>销售管理</span>
              </div>
              <div @click="yyck"  style="z-index:999;">
                  <img style="width:36px;height:36px;" src="./chuk.png" alt="">
                  <span>客户管理</span>
              </div>
          </div>
      </div>
      <!-- <img class="bg1" style="width:100%;" src="https://middle-ground.shulanhealth.com/yqjc-bg%4022x.png" alt=""> -->
      <!-- <img class="bg2" style="width:100%;" src="https://middle-ground.shulanhealth.com/yqjc-bg%4021x.png" alt=""> -->
      <!-- <van-popup v-model="showDepartmentPopup" round position="bottom">
          <div style="width: 100%;position: relative;">
              <div>
                  <input type="text" placeholder="请输入科室或病区名称">
              </div>
              <van-picker
                  title="请选择科室/病区"
                  show-toolbar
                  :columns="columns"
                  @confirm="onsjdConfirm"
                  @cancel="onsjdCancel"
              />
          </div>
      </van-popup> -->
  </div>
</template>
<script>
import {Toast} from "vant";
import dayjs from 'dayjs'
import { user } from "@/api";
export default {
  components: {
      // VanBadge: Badge
      // VanPicker: Picker,
  },
  data() {
      return {
          isAuth: false,
          showDepartmentPopup: true,
          pmHeight: 0,
          toDay: "",
          columns: [
              {
                  text: '第一病区',
                  value: '第一病区'
              }
          ],
          departmentInfo: null,
          userInfo: null
      }
  },
  filters: {
      formatDateTime(date) {
          return date !== undefined && date !== null
              ? date.substring(0, 16)
              : "";
      },
  },
  mounted() {
      
  },
  methods: {
    yyrk() {
          this.$router.push({name: 'history'})
      },
      yyck() {
          this.$router.push({name: 'customer'})
      },
  }
};
</script>
<style scoped>
.headimgurl {
  width: 60px;
  border-radius: 50%;
}
.ccwlglxt { position: absolute;top: 20px;left: 0;width:100%;color:#fff;font-size: 26px;text-align: center;font-weight: 600; }
.ccwlglxt1 { position: absolute;top: 90px;left: 0;width:100%;color:#fff;font-size: 18px;text-align: center;font-weight: 600; }
.box {width: 100%;;min-height: 100vh;position: relative;overflow: hidden;}
.bg1 {position: absolute;top: 0;left: 0;width: 100%;z-index: 1;}
.bg2 {position: absolute;bottom: 0;left: 0;width: 100%;z-index: 1;}
.head-sty {width: 44px;height: 44px;border-radius: 50%;}
.top-box {width: 90%;margin-left: 5%;display: flex;align-items: center;justify-content: space-between;margin-top: 21px;z-index: 2;}
.top-box div p {font-size: 16px;color: #000;line-height: 0;}
.riqi {display: flex;align-items: center;}
.riqi img {margin-right: 5px;}
.riqi span {font-size: 13px;color: #000;}
.sp-box {width: 92%;margin-left: 4%;height: 88px;background: #FFFFFF;box-shadow: 0px 2px 10px -4px rgba(2,66,58,0.8);border-radius: 8px;margin-top: 24px;display: flex;align-items: center;justify-content: space-between;}
.sp-box1 {width: 92%;margin-left: 4%;background: #FFFFFF;box-shadow: 0px 2px 10px -4px rgba(2,66,58,0.8);border-radius: 8px;margin-top: 24px;padding: 13px 20px;}
.sp-box div {width: 50%;text-align: center;height: 66px;display: flex;flex-direction: column;align-items: center;justify-content: space-around;}
.sp-box div p:nth-child(1) {margin: 0;font-size: 13px;color: #333333;font-weight: 500;}
.sp-box div p:nth-child(2) {margin: 0;font-size: 24px;color: #919295;font-weight: 500;}
.active-box {width: 92%;margin-left: 4%;height: 108px;display: flex;align-items: center;justify-content: space-between;margin-top: 20px;}
.active-box > div {width: 31%;display: flex;flex-direction: column;align-items: center;justify-content: center;height: 108px;background: #FFFFFF;box-shadow: 0px 2px 10px -4px rgba(2,66,58,0.8);border-radius: 8px;}
.active-box div span {margin-top: 14px;font-size: 13px;color: #333333;}

.active-box1 {width: 92%;margin-left: 4%;height: 108px;display: flex;align-items: center;justify-content: space-between;margin-top: 20px;}
.active-box1 > div {width: 48%;display: flex;flex-direction: column;align-items: center;justify-content: center;height: 108px;background: #FFFFFF;box-shadow: 0px 2px 10px -4px rgba(2,66,58,0.8);border-radius: 8px;}
.active-box1 div span {margin-top: 14px;font-size: 13px;color: #333333;}
.bqyqjc-box {width: 100%;margin-top:15px;display: flex;
align-items: center;justify-content: space-between;}
.bqyqjc-box > div:nth-child(1) {width: 48%;background: #fff;height: 97px;box-shadow: 0px 2px 10px -4px rgba(2,66,58,0.8);border-radius: 8px;display: flex;flex-direction: column;justify-content: space-between;}
.bqyqjc-box > div:nth-child(2) {width: 48%;background: #fff;height: 97px;box-shadow: 0px 2px 10px -4px rgba(2,66,58,0.8);border-radius: 8px;display: flex;flex-direction: column;justify-content: space-between;}
.arrow {border: 3px solid #B2B2B2;border-width: 0px 1px 1px 0px;display: inline-block;padding: 3px;transform: rotate(45deg);-webkit-transform: rotate(45deg);}
.qxz {height: 50px;border-radius: 8px;border: 1px solid #E0E0E0;display: flex;align-items: center;justify-content: space-between;padding: 0 15px;margin-top: 20px;z-index: 9;}
.submit-sty {height: 50px;background: #E7E8EB;border-radius: 25px;text-align: center;line-height: 50px;font-size: 16px;color: #fff;margin-top: 21px;position: relative;}
.submit-sty1 {height: 50px;background: #00AC97;border-radius: 25px;text-align: center;line-height: 50px;font-size: 16px;color: #fff;margin-top: 21px;position: relative;}
.badges{position: absolute;top: 10px;right: 10px;}
.bg-title {width: 100%;}
</style>
